// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".changeCoin {\n  padding: 0 1.5rem;\n}\n.changeCoin .item-coin {\n  border-radius: 5px;\n  border: 1px solid var(--title);\n}\n.changeCoin .item-coin .coin-icon {\n  margin-right: 1rem;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
